import io from "socket.io-client";
require('dotenv').config();

const socketUrl = process.env.VUE_APP_SOCKET_URL;

const socket = io(socketUrl);

socket.on("connect", () => {
  console.log(`Connected with ID: ${socket.id}`);
});

socket.on("disconnect", () => {
  console.log("Disconnected from server");
});

export default socket;
